import { useQuery } from "react-query";
import ShippingService from "../api/services/ShippingService";

export const useShippingOption = (
  queryKey: string,
  recordId: string,
  accessKey: string
) =>
  useQuery(
    [queryKey, recordId, accessKey],
    async () => await ShippingService.getShippingOption(recordId, accessKey),
    {
      enabled: !!recordId && !!accessKey,
      select({ data }) {
        return data?.options;
      },
    }
  );
